import HttpClient from './http';

export const sendParticipationEmail = async (
  email,
  name,
  subject,
  message,
  phoneNumber,
  from = ''
) => {
  try {
    const resp = await HttpClient.post('node-mailer/send-participation-email', {
      email,
      name,
      from,
      subject,
      message,
      phoneNumber,
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
